// extracted by mini-css-extract-plugin
module.exports = {"container":"Desktop_container__C11Sj","content":"Desktop_content__PCvIb","calendar":"Desktop_calendar__2Hv7C","count":"Desktop_count__1dCoc","day":"Desktop_day__1_mRX"};